const state = {
  arteSelecionada: null
}

const getters = {
  getArteSelecionada: (state) => {
    return state.arteSelecionada
  }
}

const mutations = {
  SETARTESELECIONADA (state, value) {
    state.arteSelecionada = value
  }
}

const actions = {
}

export default { namespaced: true, state, mutations, actions, getters }
